module.exports = __webpack_public_path__ + "img/honor-3.964a8b23.png";